'use es6';

import { ProductTypes } from '../Constants';
import makeRequest from './makeRequest';
const MANAGE_PREFERENCES_ENDPOINT = 'emailsubscriptions/v1/manage-preferences';
const PREFERENCES_ENDPOINT = 'subscriptions/v1/preferences';
export default {
  unsubscribeFromAll({
    version,
    email,
    product,
    key,
    s,
    allSubscriptionIds
  }) {
    const data = {
      subscribedIds: [],
      allSubscriptionIds
    };
    if (version === '5') {
      return makeRequest({
        data,
        method: 'put',
        query: {
          all: true,
          d: key,
          v: version,
          s,
          email
        },
        url: `${MANAGE_PREFERENCES_ENDPOINT}/starter-sales`
      });
    } else {
      const query = {
        d: key,
        all: true,
        product
      };
      if (product === ProductTypes.SALES) {
        query.email = email;
      }
      return makeRequest({
        data,
        method: 'put',
        query,
        url: `${MANAGE_PREFERENCES_ENDPOINT}/starter`
      });
    }
  },
  getSubscriptions({
    version,
    key,
    s,
    product,
    email,
    languagePreference
  }) {
    if (version === '5') {
      return makeRequest({
        earlyRequestKey: 'getSubscriptions',
        url: `${MANAGE_PREFERENCES_ENDPOINT}/starter-sales`,
        query: {
          d: key,
          v: version,
          s,
          email
        }
      });
    }
    const query = {
      d: key,
      product
    };
    if (product === ProductTypes.SALES) {
      query.email = email;
    }
    if (languagePreference) {
      query.languagePreference = languagePreference;
    }
    return makeRequest({
      earlyRequestKey: 'getSubscriptions',
      query,
      url: `${MANAGE_PREFERENCES_ENDPOINT}/starter-definitions`
    });
  },
  updateSubscriptions({
    version,
    email,
    s,
    key,
    optedInIds,
    originalIds,
    product
  }) {
    const data = {
      subscribedIds: optedInIds,
      allSubscriptionIds: originalIds
    };
    if (version === '5') {
      return makeRequest({
        method: 'put',
        url: `${MANAGE_PREFERENCES_ENDPOINT}/starter-sales`,
        query: {
          d: key,
          v: version,
          s,
          email
        },
        data
      });
    }
    const query = {
      d: key,
      product
    };
    if (product === ProductTypes.SALES) {
      query.email = email;
    }
    if (optedInIds.size === 0) {
      query.all = true;
    }
    return makeRequest({
      data,
      method: 'put',
      query,
      url: `${MANAGE_PREFERENCES_ENDPOINT}/starter`
    });
  },
  getPreferencesInformation({
    key,
    languagePreference
  }) {
    return makeRequest({
      earlyRequestKey: 'getPreferencesInformation',
      query: {
        d: key,
        languagePreference: languagePreference || null
      },
      url: `${PREFERENCES_ENDPOINT}/render-information`
    });
  },
  getTestPreferencesInformation(key, groupId, languagePreference) {
    return makeRequest({
      earlyRequestKey: 'getTestPreferencesInformation',
      query: {
        d: key,
        groupId,
        languagePreference
      },
      url: `${PREFERENCES_ENDPOINT}/render-information-test`
    });
  },
  updatePreferencesInformation({
    brandId,
    key,
    optedInIds,
    originalIds
  }) {
    const isUnsubscribeAll = optedInIds.length === 0;
    const unsubsCsv = originalIds.filter(id => !optedInIds.includes(id)).join(',');
    return makeRequest({
      data: {
        isUnsubscribeAll,
        brandId,
        subscribedIds: optedInIds,
        allSubDefIds: originalIds
      },
      method: 'put',
      query: {
        all: isUnsubscribeAll,
        d: key,
        unsubsCsv,
        subsCsv: optedInIds.join(',')
      },
      url: `${PREFERENCES_ENDPOINT}/update-preferences`
    });
  },
  getBrandInformation({
    version,
    key,
    s,
    product
  }) {
    if (version === '5') {
      return makeRequest({
        earlyRequestKey: 'getBrandInformation',
        url: `${PREFERENCES_ENDPOINT}/sales-portal-information`,
        query: {
          d: key,
          v: version,
          s
        }
      });
    }
    return makeRequest({
      earlyRequestKey: 'getBrandInformation',
      query: {
        d: key,
        product
      },
      url: `${PREFERENCES_ENDPOINT}/portal-information`
    });
  },
  checkRedirect({
    key,
    version,
    product,
    email,
    s
  }) {
    return makeRequest({
      query: {
        d: key,
        v: version,
        product,
        email,
        s
      },
      url: `${PREFERENCES_ENDPOINT}/redirect`
    });
  }
};